import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconChevronUp } from '@calendly/ui/components/glyphs/IconChevronUp';
import { IconPlus } from '@calendly/ui/components/glyphs/IconPlus';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationOptionSections, LocationOptionsPanel } from './location_options_panel';
const wrapperCss = "wfvvb6f";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const AddAnotherLocationOption = ({
  onSelect,
  possibleKinds,
  filteredLocations
}) => {
  const [toggleDropdown, Dropdown, isOpen] = useDropdown();
  const takenKinds = filteredLocations.map(({
    kind
  }) => kind);
  const handleSelect = kind => {
    onSelect(kind);
    toggleDropdown();
  };
  return <Wrapper>
      <Button appearance="ghost" size="small" aria-expanded={isOpen} onClick={toggleDropdown}>
        <UiIcon icon={IconPlus} size="small" title="" />
        {I18n.t('publisher.event_type_editor_crud.meeting_details.location.add_option_label')}
        {isOpen && <UiIcon icon={IconChevronUp} size="small" title="" />}
      </Button>
      <Dropdown>
        <LocationOptionsPanel>
          <LocationOptionSections possibleKinds={possibleKinds} takenKinds={takenKinds} onSelect={handleSelect} />
        </LocationOptionsPanel>
      </Dropdown>
    </Wrapper>;
};

require("./add_location_option.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./add_location_option.js");